import { IUploaderForm } from '@/types/uploadForm.interface'

/**
 * Returns default empty values for the upload form
 */
export const getDefaultFormValues = (): IUploaderForm => {
	return {
		title: '',
		description: '',
		location: '',
		categories: [],
		tags: [],
		region: null,
		country: null,
		rights: '',
		UAERegulatedContent: '',
		source: '',
		restrictions: ''
	}
}
